import { render } from "./the-tracks-card.vue?vue&type=template&id=c7097186&scoped=true&ts=true"
import script from "./the-tracks-card.vue?vue&type=script&lang=ts"
export * from "./the-tracks-card.vue?vue&type=script&lang=ts"

import "./the-tracks-card.vue?vue&type=style&index=0&id=c7097186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7097186"]])

export default __exports__